function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.62,17.29a.34.34,0,0,0,.31,0l2.2-2.2,5,4.88a.33.33,0,0,0,.4,0l3.24-3.24a.25.25,0,0,0,0-.35l0,0-5-5,2.2-2.2a.24.24,0,0,0,0-.3.32.32,0,0,0-.27-.2H6.72a.27.27,0,0,0-.29.25V17A.28.28,0,0,0,6.62,17.29Z",
    style: {
      fill: "#e54918"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.47,
    y: 20.39,
    width: 19.11,
    height: 5.11,
    style: {
      fill: "#e54918"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.67,
    y: 10.87,
    width: 14.47,
    height: 5.11,
    transform: "translate(-4.25 16.59) rotate(-45)",
    style: {
      fill: "#e54918"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissed);
export default __webpack_public_path__ + "static/media/missed.b824aca6.svg";
export { ForwardRef as ReactComponent };